'use strict';

import AppDispatcher from '../core/AppDispatcher.jsx';
import Constants from '../constants/DeclarationConstants';

module.exports = {
    toggleHiddenSpinner: function (data) {
        AppDispatcher.dispatch({
            actionType: Constants.HIDE_SPINNER,
            hideSpinner: data
        });
    },
    toggleEligibilityCheckComplete: () => {
        AppDispatcher.dispatch({
            actionType: Constants.TOGGLE_ELIGIBILITY_CHECK_COMPLETE
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/DeclarationActions.js